import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, first, map, switchMap } from 'rxjs/operators';

import { IdealModelsTransformer } from './ideal.transformer';

import { ApiIdealBank } from '@api/_api/api-payment/api-ideal.model';
import { ApiIdealService } from '@api/_api/api-payment/api-ideal.service';
import { StoreAndLanguage } from '@core/domain/state/core.state';
import { getStoreAndLanguage } from '@core/infrastructure/state/core.selectors';

// import { UserService } from 'idt-ecommerce-api/users/user.service';

@Injectable()
export class IdealService {
    constructor(
        private readonly apiIdealService: ApiIdealService,
        private readonly store: Store,
    ) {}

    public getIdealBanks(): Observable<ApiIdealBank[]> {
        return this.store.select(getStoreAndLanguage).pipe(
            first(),
            switchMap((storeAndLanguage: StoreAndLanguage) => {
                return this.apiIdealService.getIdealBanks(storeAndLanguage.storeId, storeAndLanguage.languageId).pipe(
                    map((idealBank)=>{
                        return IdealModelsTransformer.IdealBanksFromApi(idealBank);
                    })
                );
            }),
            catchError((error: unknown) => {
                console.error(error);
                return throwError(() => error);
            })
        );
    }
}
